import React, { useRef, useState, useCallback } from "react";
import html2canvas from "html2canvas";
import Cropper from "react-easy-crop";
import { AuthServices } from "../../../services/AuthServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import ReferenceDocFlow from "./ReferenceDocFlow";
import { Close } from "@mui/icons-material";
import { useFormikContext } from "formik";
const ScreenshotWrapper = ({ index, caseDetails, setIsScreenshotOpen }) => {
  const componentRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const { setFieldValue } = useFormikContext();
  // Take screenshot and show crop modal
  const handleScreenshot = async () => {
    if (componentRef.current) {
      const canvas = await html2canvas(componentRef.current);
      const dataUrl = canvas.toDataURL("image/png");
      setImageSrc(dataUrl);
      setShowCropper(true);
    }
  };

  const createImage = (url) =>
    new Promise((resolve, reject) => {
      const image = new Image();
      image.addEventListener("load", () => resolve(image));
      image.addEventListener("error", (error) => reject(error));
      image.src = url;
    });

  const onCropComplete = useCallback((_, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  // Convert base64 to File
  const base64ToFile = (base64, filename) => {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };

  // Upload cropped image to S3
  const uploadCroppedImage = useCallback(async () => {
    if (!imageSrc || !croppedAreaPixels) return;

    const image = await createImage(imageSrc);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    canvas.width = croppedAreaPixels.width;
    canvas.height = croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      croppedAreaPixels.width,
      croppedAreaPixels.height
    );

    const croppedDataUrl = canvas.toDataURL("image/png");
    const file = base64ToFile(croppedDataUrl, "chat-screenshot.png");

    // Now use your uploadImage function logic
    if (file.size > 5242880) {
      window.alert("Please upload a file smaller than 5 MB");
    } else {
      try {
        let data = new FormData();
        data.append("image", file);
        let res = await AuthServices.uploadImage(data); // Upload to S3
        window.alert("Image uploaded successfully");
        setFieldValue(
          `caseProcedures.${index}.procedureApprovalUrl`,
          res?.data?.url
        );
      } catch (error) {
        handleApiErrorResponses(error);
      }
    }

    setShowCropper(false);
  }, [imageSrc, croppedAreaPixels]);

  return (
    <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center p-4 bg-[#017C5780] z-[1201]">
      <div className=" w-[80%] 2xl:w-[70%] h-[80%] bg-white bg-red-200 p-4 xl:p-8 rounded-[20px]">
        <div className="flex justify-end items-center gap-5">
          {/* <button
            type="button"
            onClick={handleScreenshot}
            className={`relative bg-[#017C57] text-white border-none px-4 py-2 rounded-lg z-[1220]`}
          >
            📸 Take Screenshot
          </button> */}

          <Close
            className="cursor-pointer"
            onClick={() => setIsScreenshotOpen(false)}
          />
        </div>
        <div ref={componentRef} className="h-full">
          <ReferenceDocFlow
            caseDetails={caseDetails}
            isScreenshot={true}
            index={index}
            setIsScreenshotOpen={setIsScreenshotOpen}
          />
        </div>

        {showCropper && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex flex-col items-center justify-center z-[1220]">
            <div className="relative w-[80vw] h-[80vh] bg-gray-900">
              <Cropper
                image={imageSrc}
                crop={crop}
                zoom={zoom}
                aspect={4 / 3}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </div>
            <div className="mt-4 flex gap-4">
              <button
                type="button"
                onClick={uploadCroppedImage}
                className="bg-blue-500 text-white px-4 py-2 rounded-lg"
              >
                Save & Upload
              </button>
              <button
                type="button"
                onClick={() => setShowCropper(false)}
                className="bg-gray-500 text-white px-4 py-2 rounded-lg"
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ScreenshotWrapper;
